export default __webpack_public_path__ + "static/media/christmasLogoSingle.a5f89127.svg";